module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n9n2n5n-ed1d3acde182fad0b46e392c30891e12.svg";